import { render, staticRenderFns } from "./answerView1.vue?vue&type=template&id=6e651e6d&scoped=true"
import script from "./answerView1.vue?vue&type=script&lang=js"
export * from "./answerView1.vue?vue&type=script&lang=js"
import style0 from "./answerView1.vue?vue&type=style&index=0&id=6e651e6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e651e6d",
  null
  
)

export default component.exports